export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MIN_SCORE = 3;

/** POS / caissiers: saisie quotidienne, compromis mémorisation / sécurité. */
export const TICKETACK_USER_PASSWORD_MIN_LENGTH = 7;
export const TICKETACK_USER_PASSWORD_MIN_SCORE = 2;

export const isPasswordAcceptable = (
    result,
    password,
    _userInputs = [],
    minScore = PASSWORD_MIN_SCORE,
    minLength = PASSWORD_MIN_LENGTH
) => {
    if (!password || password.length < minLength) {
        return false;
    }

    if (!result || typeof result.score !== 'number') {
        return false;
    }

    return result.score >= minScore;
};

export const passwordStrengthLabelKey = (score) => {
    if (score <= 0) {
        return 'password.strength.very_weak';
    }
    if (score === 1) {
        return 'password.strength.weak';
    }
    if (score === 2) {
        return 'password.strength.fair';
    }
    if (score === 3) {
        return 'password.strength.good';
    }
    return 'password.strength.strong';
};

export const passwordStrengthBarClass = (score) => {
    if (score <= 0) {
        return 'PasswordInput-strengthBar-fill--0';
    }
    if (score === 1) {
        return 'PasswordInput-strengthBar-fill--1';
    }
    if (score === 2) {
        return 'PasswordInput-strengthBar-fill--2';
    }
    if (score === 3) {
        return 'PasswordInput-strengthBar-fill--3';
    }
    return 'PasswordInput-strengthBar-fill--4';
};
